/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const BalanceState = zod
	.object({
		balance_usd: zod.string().nullable().describe('Current balance in USD')
	})
	.describe('Prepaid balance state');

export type BalanceState = zod.input<typeof BalanceState>;
export type BalanceStateOutput = zod.output<typeof BalanceState>;
